import { AlarmRoutes } from "./AlarmRoutes";
import { ProductUUID } from "namirasoft-api-product";
import { NamirasoftMap } from "namirasoft-site-map";
import { ProductRow } from "namirasoft-alarm";
import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { AlarmRow, AlarmInputRow } from "namirasoft-alarm";
import { BaseColumnFormatter, BooleanFormatter, DateTimeFormatter, IDFormatter, IntegerFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { IStorageLocal, NamingConvention } from "namirasoft-core";
import { AlarmProps } from "./AlarmProps";

export class AlarmEntities
{
    static getEntities(product: ProductRow | null): string[]
    {
        let ans = Object.keys(product?.alarm ?? {}).map(table => NamingConvention.auto.convert(table, NamingConvention.Pascal_Case));
        if (product)
            try
            {
                let namirasoft = new NamirasoftMap();
                let entities = namirasoft.getByProductID(product.id).getTables().map(table => NamingConvention.auto.convert(table.name, NamingConvention.Pascal_Case));
                ans = ans.filter(entity => entities.includes(entity));
            } catch (error)
            {
            }
        ans = ans.sort();
        return ans;
    }
    static getActions(product: ProductRow | null, entity?: string | null): string[]
    {
        entity = NamingConvention.auto.convert(entity ?? "", NamingConvention.Pascal_Case);
        let ans: string[] = product?.alarm?.[entity] ?? [];
        ans = ans.map(action => NamingConvention.auto.convert(action, NamingConvention.lower_case_underscore));
        return ans;
    }
    static alarm(props: NSARouterMakerResult & AlarmProps): IEntityInfo<AlarmRow, AlarmInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

        return {
            product_id: ProductUUID.NAMIRASOFT_ALARM,
            name: "alarm",
            tables: [{ table: namirasoft.alarm.tables.alarm, required: true }],
            client: {
                getColumns()
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.product_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.topic_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.entity, new StringFormatter(StringFormatterSizeType.TwoWords, NamingConvention.Pascal_Case_Space)),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.action, new StringFormatter(StringFormatterSizeType.TwoWords, NamingConvention.Pascal_Case_Space)),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.limit, new BooleanFormatter("Yes", "No")),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.limit_count, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.limit_per_value, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.limit_per_unit, new StringFormatter(StringFormatterSizeType.Word)),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.aggregation, new BooleanFormatter("Yes", "No")),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.aggregation_interval_value, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.aggregation_interval_unit, new StringFormatter(StringFormatterSizeType.Word)),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.aggregation_function, new StringFormatter(StringFormatterSizeType.Word)),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.aggregation_column, new StringFormatter(StringFormatterSizeType.TwoWords)),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.aggregation_operator, new StringFormatter(StringFormatterSizeType.Word)),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.aggregation_value, new StringFormatter(StringFormatterSizeType.TwoWords)),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.alarm.tables.alarm.columns.updated_at, new DateTimeFormatter()),
                    ]
                },
                getListURL: () => AlarmRoutes.AlarmList,
                getNewURL: () => AlarmRoutes.AlarmNew,
                getCopyURL: (id: string) => AlarmRoutes.AlarmCopy(id),
                getEditURL: (id: string) => AlarmRoutes.AlarmEdit(id),
                getViewURL: (id: string) => AlarmRoutes.AlarmView(id),
            },
            server: {
                value_list: props.servers.alarm.value.List,
                get: props.servers.alarm.alarm.Get,
                list: props.servers.alarm.alarm.List,
                create: props.servers.alarm.alarm.Create,
                update: props.servers.alarm.alarm.Update,
                delete: props.servers.alarm.alarm.Delete
            }
        };
    }
}